export const getCountries = t => [
  { value: 'Afghanistan', text: t('Afghanistan') },
  { value: 'Åland Islands', text: t('Åland Islands') },
  { value: 'Albania', text: t('Albania') },
  { value: 'Algeria', text: t('Algeria') },
  { value: 'Andorra', text: t('Andorra') },
  { value: 'Angola', text: t('Angola') },
  { value: 'Anguilla', text: t('Anguilla') },
  { value: 'Antarctica', text: t('Antarctica') },
  { value: 'Antigua and Barbuda', text: t('Antigua and Barbuda') },
  { value: 'Argentina', text: t('Argentina') },
  { value: 'Armenia', text: t('Armenia') },
  { value: 'Aruba', text: t('Aruba') },
  { value: 'Australia', text: t('Australia') },
  { value: 'Austria', text: t('Austria') },
  { value: 'Azerbaijan', text: t('Azerbaijan') },
  { value: 'Bahamas', text: t('Bahamas') },
  { value: 'Bahrain', text: t('Bahrain') },
  { value: 'Bangladesh', text: t('Bangladesh') },
  { value: 'Barbados', text: t('Barbados') },
  { value: 'Belarus', text: t('Belarus') },
  { value: 'Belgium', text: t('Belgium') },
  { value: 'Belize', text: t('Belize') },
  { value: 'Benin', text: t('Benin') },
  { value: 'Bermuda', text: t('Bermuda') },
  { value: 'Bhutan', text: t('Bhutan') },
  {
    value: 'Bolivia, Plurinational State of',
    text: t('Bolivia, Plurinational State of')
  },
  {
    value: 'Bonaire, Sint Eustatius and Saba',
    text: t('Bonaire, Sint Eustatius and Saba')
  },
  { value: 'Bosnia and Herzegovina', text: t('Bosnia and Herzegovina') },
  { value: 'Botswana', text: t('Botswana') },
  { value: 'Bouvet Island', text: t('Bouvet Island') },
  { value: 'Brazil', text: t('Brazil') },
  {
    value: 'British Indian Ocean Territory',
    text: t('British Indian Ocean Territory')
  },
  { value: 'Brunei Darussalam', text: t('Brunei Darussalam') },
  { value: 'Bulgaria', text: t('Bulgaria') },
  { value: 'Burkina Faso', text: t('Burkina Faso') },
  { value: 'Burundi', text: t('Burundi') },
  { value: 'Cambodia', text: t('Cambodia') },
  { value: 'Cameroon', text: t('Cameroon') },
  { value: 'Canada', text: t('Canada') },
  { value: 'Cape Verde', text: t('Cape Verde') },
  { value: 'Cayman Islands', text: t('Cayman Islands') },
  { value: 'Central African Republic', text: t('Central African Republic') },
  { value: 'Chad', text: t('Chad') },
  { value: 'Chile', text: t('Chile') },
  { value: 'China', text: t('China') },
  { value: 'Christmas Island', text: t('Christmas Island') },
  { value: 'Cocos (Keeling) Islands', text: t('Cocos (Keeling) Islands') },
  { value: 'Colombia', text: t('Colombia') },
  { value: 'Comoros', text: t('Comoros') },
  { value: 'Congo', text: t('Congo') },
  {
    value: 'Congo, the Democratic Republic of the',
    text: t('Congo, the Democratic Republic of the')
  },
  { value: 'Cook Islands', text: t('Cook Islands') },
  { value: 'Costa Rica', text: t('Costa Rica') },
  { value: "Côte d'Ivoire", text: t("Côte d'Ivoire") },
  { value: 'Croatia', text: t('Croatia') },
  { value: 'Cuba', text: t('Cuba') },
  { value: 'Curaçao', text: t('Curaçao') },
  { value: 'Cyprus', text: t('Cyprus') },
  { value: 'Czech Republic', text: t('Czech Republic') },
  { value: 'Denmark', text: t('Denmark') },
  { value: 'Djibouti', text: t('Djibouti') },
  { value: 'Dominica', text: t('Dominica') },
  { value: 'Dominican Republic', text: t('Dominican Republic') },
  { value: 'Ecuador', text: t('Ecuador') },
  { value: 'Egypt', text: t('Egypt') },
  { value: 'El Salvador', text: t('El Salvador') },
  { value: 'Equatorial Guinea', text: t('Equatorial Guinea') },
  { value: 'Eritrea', text: t('Eritrea') },
  { value: 'Estonia', text: t('Estonia') },
  { value: 'Ethiopia', text: t('Ethiopia') },
  {
    value: 'Falkland Islands (Malvinas)',
    text: t('Falkland Islands (Malvinas)')
  },
  { value: 'Faroe Islands', text: t('Faroe Islands') },
  { value: 'Fiji', text: t('Fiji') },
  { value: 'Finland', text: t('Finland') },
  { value: 'France', text: t('France') },
  { value: 'French Guiana', text: t('French Guiana') },
  { value: 'French Polynesia', text: t('French Polynesia') },
  {
    value: 'French Southern Territories',
    text: t('French Southern Territories')
  },
  { value: 'Gabon', text: t('Gabon') },
  { value: 'Gambia', text: t('Gambia') },
  { value: 'Georgia', text: t('Georgia') },
  { value: 'Germany', text: t('Germany') },
  { value: 'Ghana', text: t('Ghana') },
  { value: 'Gibraltar', text: t('Gibraltar') },
  { value: 'Greece', text: t('Greece') },
  { value: 'Greenland', text: t('Greenland') },
  { value: 'Grenada', text: t('Grenada') },
  { value: 'Guadeloupe', text: t('Guadeloupe') },
  { value: 'Guatemala', text: t('Guatemala') },
  { value: 'Guernsey', text: t('Guernsey') },
  { value: 'Guinea', text: t('Guinea') },
  { value: 'Guinea-Bissau', text: t('Guinea-Bissau') },
  { value: 'Guyana', text: t('Guyana') },
  { value: 'Haiti', text: t('Haiti') },
  {
    value: 'Heard Island and McDonald Islands',
    text: t('Heard Island and McDonald Islands')
  },
  {
    value: 'Holy See (Vatican City State)',
    text: t('Holy See (Vatican City State)')
  },
  { value: 'Honduras', text: t('Honduras') },
  { value: 'Hong Kong', text: t('Hong Kong') },
  { value: 'Hungary', text: t('Hungary') },
  { value: 'Iceland', text: t('Iceland') },
  { value: 'India', text: t('India') },
  { value: 'Indonesia', text: t('Indonesia') },
  { value: 'Iran, Islamic Republic of', text: t('Iran, Islamic Republic of') },
  { value: 'Iraq', text: t('Iraq') },
  { value: 'Ireland', text: t('Ireland') },
  { value: 'Isle of Man', text: t('Isle of Man') },
  { value: 'Israel', text: t('Israel') },
  { value: 'Italy', text: t('Italy') },
  { value: 'Jamaica', text: t('Jamaica') },
  { value: 'Japan', text: t('Japan') },
  { value: 'Jersey', text: t('Jersey') },
  { value: 'Jordan', text: t('Jordan') },
  { value: 'Kazakhstan', text: t('Kazakhstan') },
  { value: 'Kenya', text: t('Kenya') },
  { value: 'Kiribati', text: t('Kiribati') },
  {
    value: "Korea, Democratic People's Republic of",
    text: t("Korea, Democratic People's Republic of")
  },
  { value: 'Korea', text: t('Korea') },
  { value: 'Kuwait', text: t('Kuwait') },
  { value: 'Kyrgyzstan', text: t('Kyrgyzstan') },
  {
    value: "Lao People's Democratic Republic",
    text: t("Lao People's Democratic Republic")
  },
  { value: 'Latvia', text: t('Latvia') },
  { value: 'Lebanon', text: t('Lebanon') },
  { value: 'Lesotho', text: t('Lesotho') },
  { value: 'Liberia', text: t('Liberia') },
  { value: 'Libya', text: t('Libya') },
  { value: 'Liechtenstein', text: t('Liechtenstein') },
  { value: 'Lithuania', text: t('Lithuania') },
  { value: 'Luxembourg', text: t('Luxembourg') },
  { value: 'Macao', text: t('Macao') },
  {
    value: 'Macedonia, the former Yugoslav Republic of',
    text: t('Macedonia, the former Yugoslav Republic of')
  },
  { value: 'Madagascar', text: t('Madagascar') },
  { value: 'Malawi', text: t('Malawi') },
  { value: 'Malaysia', text: t('Malaysia') },
  { value: 'Maldives', text: t('Maldives') },
  { value: 'Mali', text: t('Mali') },
  { value: 'Malta', text: t('Malta') },
  { value: 'Martinique', text: t('Martinique') },
  { value: 'Mauritania', text: t('Mauritania') },
  { value: 'Mauritius', text: t('Mauritius') },
  { value: 'Mayotte', text: t('Mayotte') },
  { value: 'Mexico', text: t('Mexico') },
  { value: 'Moldova, Republic of', text: t('Moldova, Republic of') },
  { value: 'Monaco', text: t('Monaco') },
  { value: 'Mongolia', text: t('Mongolia') },
  { value: 'Montenegro', text: t('Montenegro') },
  { value: 'Montserrat', text: t('Montserrat') },
  { value: 'Morocco', text: t('Morocco') },
  { value: 'Mozambique', text: t('Mozambique') },
  { value: 'Myanmar', text: t('Myanmar') },
  { value: 'Namibia', text: t('Namibia') },
  { value: 'Nauru', text: t('Nauru') },
  { value: 'Nepal', text: t('Nepal') },
  { value: 'Netherlands', text: t('Netherlands') },
  { value: 'New Caledonia', text: t('New Caledonia') },
  { value: 'New Zealand', text: t('New Zealand') },
  { value: 'Nicaragua', text: t('Nicaragua') },
  { value: 'Niger', text: t('Niger') },
  { value: 'Nigeria', text: t('Nigeria') },
  { value: 'Niue', text: t('Niue') },
  { value: 'Norfolk Island', text: t('Norfolk Island') },
  { value: 'Norway', text: t('Norway') },
  { value: 'Oman', text: t('Oman') },
  { value: 'Pakistan', text: t('Pakistan') },
  { value: 'Palestine, State of', text: t('Palestine, State of') },
  { value: 'Panama', text: t('Panama') },
  { value: 'Papua New Guinea', text: t('Papua New Guinea') },
  { value: 'Paraguay', text: t('Paraguay') },
  { value: 'Peru', text: t('Peru') },
  { value: 'Philippines', text: t('Philippines') },
  { value: 'Pitcairn', text: t('Pitcairn') },
  { value: 'Poland', text: t('Poland') },
  { value: 'Portugal', text: t('Portugal') },
  { value: 'Qatar', text: t('Qatar') },
  { value: 'Réunion', text: t('Réunion') },
  { value: 'Romania', text: t('Romania') },
  { value: 'Russian Federation', text: t('Russian Federation') },
  { value: 'Rwanda', text: t('Rwanda') },
  { value: 'Saint Barthélemy', text: t('Saint Barthélemy') },
  {
    value: 'Saint Helena, Ascension and Tristan da Cunha',
    text: t('Saint Helena, Ascension and Tristan da Cunha')
  },
  { value: 'Saint Kitts and Nevis', text: t('Saint Kitts and Nevis') },
  { value: 'Saint Lucia', text: t('Saint Lucia') },
  {
    value: 'Saint Martin (French part)',
    text: t('Saint Martin (French part)')
  },
  { value: 'Saint Pierre and Miquelon', text: t('Saint Pierre and Miquelon') },
  {
    value: 'Saint Vincent and the Grenadines',
    text: t('Saint Vincent and the Grenadines')
  },
  { value: 'Samoa', text: t('Samoa') },
  { value: 'San Marino', text: t('San Marino') },
  { value: 'Sao Tome and Principe', text: t('Sao Tome and Principe') },
  { value: 'Saudi Arabia', text: t('Saudi Arabia') },
  { value: 'Senegal', text: t('Senegal') },
  { value: 'Serbia', text: t('Serbia') },
  { value: 'Seychelles', text: t('Seychelles') },
  { value: 'Sierra Leone', text: t('Sierra Leone') },
  { value: 'Singapore', text: t('Singapore') },
  { value: 'Sint Maarten (Dutch part)', text: t('Sint Maarten (Dutch part)') },
  { value: 'Slovakia', text: t('Slovakia') },
  { value: 'Slovenia', text: t('Slovenia') },
  { value: 'Solomon Islands', text: t('Solomon Islands') },
  { value: 'Somalia', text: t('Somalia') },
  { value: 'South Africa', text: t('South Africa') },
  {
    value: 'South Georgia and the South Sandwich Islands',
    text: t('South Georgia and the South Sandwich Islands')
  },
  { value: 'South Sudan', text: t('South Sudan') },
  { value: 'Spain', text: t('Spain') },
  { value: 'Sri Lanka', text: t('Sri Lanka') },
  { value: 'Sudan', text: t('Sudan') },
  { value: 'Suriname', text: t('Suriname') },
  { value: 'Svalbard and Jan Mayen', text: t('Svalbard and Jan Mayen') },
  { value: 'Swaziland', text: t('Swaziland') },
  { value: 'Sweden', text: t('Sweden') },
  { value: 'Switzerland', text: t('Switzerland') },
  { value: 'Syrian Arab Republic', text: t('Syrian Arab Republic') },
  { value: 'Taiwan', text: t('Taiwan') },
  { value: 'Tajikistan', text: t('Tajikistan') },
  {
    value: 'Tanzania, United Republic of',
    text: t('Tanzania, United Republic of')
  },
  { value: 'Thailand', text: t('Thailand') },
  { value: 'Timor-Leste', text: t('Timor-Leste') },
  { value: 'Togo', text: t('Togo') },
  { value: 'Tokelau', text: t('Tokelau') },
  { value: 'Tonga', text: t('Tonga') },
  { value: 'Trinidad and Tobago', text: t('Trinidad and Tobago') },
  { value: 'Tunisia', text: t('Tunisia') },
  { value: 'Turkey', text: t('Turkey') },
  { value: 'Turkmenistan', text: t('Turkmenistan') },
  { value: 'Turks and Caicos Islands', text: t('Turks and Caicos Islands') },
  { value: 'Tuvalu', text: t('Tuvalu') },
  { value: 'Uganda', text: t('Uganda') },
  { value: 'Ukraine', text: t('Ukraine') },
  { value: 'United Arab Emirates', text: t('United Arab Emirates') },
  { value: 'United Kingdom', text: t('United Kingdom') },
  { value: 'United States', text: t('United States') },
  { value: 'Uruguay', text: t('Uruguay') },
  { value: 'Uzbekistan', text: t('Uzbekistan') },
  { value: 'Vanuatu', text: t('Vanuatu') },
  {
    value: 'Venezuela, Bolivarian Republic of',
    text: t('Venezuela, Bolivarian Republic of')
  },
  { value: 'Viet Nam', text: t('Viet Nam') },
  { value: 'Virgin Islands, British', text: t('Virgin Islands, British') },
  { value: 'Wallis and Futuna', text: t('Wallis and Futuna') },
  { value: 'Western Sahara', text: t('Western Sahara') },
  { value: 'Yemen', text: t('Yemen') },
  { value: 'Zambia', text: t('Zambia') },
  { value: 'Zimbabwe', text: t('Zimbabwe') }
];

export const getOccupations = t => [
  { value: 'Architect', text: t('Architect') },
  {
    value: 'Artist / Character Modeler',
    text: t('Artist / Character Modeler')
  },
  { value: 'Dentist', text: t('Dentist') },
  { value: 'Dental Lab Specialist', text: t('Dental Lab Specialist') },
  { value: 'Orthodontist', text: t('Orthodontist') },
  { value: 'Ortho Lab Specialist', text: t('Ortho Lab Specialist') },
  { value: 'Educator (K-12)', text: t('Educator (K-12)') },
  {
    value: 'Educator (Community and 2yr Colleges)',
    text: t('Educator (Community and 2yr Colleges)')
  },
  {
    value: 'Educator (4yr Colleges and Universities)',
    text: t('Educator (4yr Colleges and Universities)')
  },
  { value: 'Engineer', text: t('Engineer') },
  { value: 'Jewelry Designer', text: t('Jewelry Designer') },
  { value: 'Maker / Hobbyist', text: t('Maker / Hobbyist') },
  {
    value: 'Manufacturing / Manufacturing Engineer',
    text: t('Manufacturing / Manufacturing Engineer')
  },
  { value: 'Medical Professional', text: t('Medical Professional') },
  { value: 'Product Designer', text: t('Product Designer') },
  { value: 'Purchasing / Procurement', text: t('Purchasing / Procurement') },
  { value: 'Researcher', text: t('Researcher') },
  { value: 'Student', text: t('Student') },
  { value: 'Other', text: t('Other') }
];

export const getIndustries = t => [
  { value: 'Aerospace / Defense', text: t('Aerospace / Defense') },
  { value: 'Anatomical', text: t('Anatomical') },
  { value: 'Architecture', text: t('Architecture') },
  { value: 'Arts / Entertainment', text: t('Arts / Entertainment') },
  { value: 'Audiology', text: t('Audiology') },
  { value: 'Automotive', text: t('Automotive') },
  { value: 'Orthodontic Practice', text: t('Orthodontic Practice') },
  { value: 'Orthodontic Lab', text: t('Orthodontic Lab') },
  { value: 'Dental Lab', text: t('Dental Lab') },
  { value: 'Dental Practice', text: t('Dental Practice') },
  { value: 'Education (K-12)', text: t('Education (K-12)') },
  {
    value: 'Educator (Community and 2yr Colleges)',
    text: t('Educator (Community and 2yr Colleges)')
  },
  {
    value: 'Educator (4yr Colleges and Universities)',
    text: t('Educator (4yr Colleges and Universities)')
  },
  {
    value: 'Engineering / Design Consulting',
    text: t('Engineering / Design Consulting')
  },
  { value: 'Government', text: t('Government') },
  { value: 'Jewelry Casting', text: t('Jewelry Casting') },
  { value: 'Jewelry Design', text: t('Jewelry Design') },
  { value: 'Makerspace', text: t('Makerspace') },
  { value: 'Manufacturing', text: t('Manufacturing') },
  { value: 'Medical', text: t('Medical') },
  { value: 'Medical Devices', text: t('Medical Devices') },
  { value: 'Orthotics', text: t('Orthotics') },
  { value: 'Product Design', text: t('Product Design') },
  { value: 'Reseller', text: t('Reseller') },
  { value: 'Service Bureau', text: t('Service Bureau') }
];

export const getFactorySolutionsIndustries = t => [
  { value: 'Aerospace / Defense', text: t('Aerospace / Defense') },
  { value: 'Agricultural Machinery', text: t('Agricultural Machinery') },
  { value: 'Arts / Entertainment', text: t('Arts / Entertainment') },
  { value: 'Audiology', text: t('Audiology') },
  { value: 'Automotive', text: t('Automotive') },
  {
    value: 'Biotechnology/Pharmaceuticals',
    text: t('Biotechnology/Pharmaceuticals')
  },
  {
    value: 'Chemicals, Plastics & Rubber',
    text: t('Chemicals, Plastics & Rubber')
  },
  { value: 'Construction', text: t('Construction') },
  { value: 'Consumer Products', text: t('Consumer Products') },
  { value: 'Dental Lab', text: t('Dental Lab') },
  {
    value: 'Education (4yr Colleges and Universities)',
    text: t('Education (4yr Colleges and Universities)')
  },
  { value: 'Government', text: t('Government') },
  {
    value: 'Industrial Machinery/Tools & Equipment',
    text: t('Industrial Machinery/Tools & Equipment')
  },
  { value: 'Jewelry Caster', text: t('Jewelry Caster') },
  { value: 'Manufacturing', text: t('Manufacturing') },
  { value: 'Medical', text: t('Medical') },
  { value: 'Medical Devices', text: t('Medical Devices') },
  { value: 'Ortho Lab', text: t('Ortho Lab') },
  { value: 'Orthotics', text: t('Orthotics') },
  { value: 'Professional Services', text: t('Professional Services') },
  { value: 'Robotics/Automation', text: t('Robotics/Automation') },
  { value: 'Service Bureau', text: t('Service Bureau') },
  { value: 'Textiles', text: t('Textiles') },
  { value: 'Other', text: t('Other') }
];

export const getStates = t => [
  { value: 'Alabama', text: t('Alabama') },
  { value: 'Alaska', text: t('Alaska') },
  { value: 'Arizona', text: t('Arizona') },
  { value: 'Arkansas', text: t('Arkansas') },
  { value: 'California', text: t('California') },
  { value: 'Colorado', text: t('Colorado') },
  { value: 'Connecticut', text: t('Connecticut') },
  { value: 'Delaware', text: t('Delaware') },
  { value: 'Florida', text: t('Florida') },
  { value: 'Georgia', text: t('Georgia') },
  { value: 'Hawaii', text: t('Hawaii') },
  { value: 'Idaho', text: t('Idaho') },
  { value: 'Illinois', text: t('Illinois') },
  { value: 'Indiana', text: t('Indiana') },
  { value: 'Iowa', text: t('Iowa') },
  { value: 'Kansas', text: t('Kansas') },
  { value: 'Kentucky', text: t('Kentucky') },
  { value: 'Louisiana', text: t('Louisiana') },
  { value: 'Maine', text: t('Maine') },
  { value: 'Maryland', text: t('Maryland') },
  { value: 'Massachusetts', text: t('Massachusetts') },
  { value: 'Michigan', text: t('Michigan') },
  { value: 'Minnesota', text: t('Minnesota') },
  { value: 'Mississippi', text: t('Mississippi') },
  { value: 'Missouri', text: t('Missouri') },
  { value: 'Montana', text: t('Montana') },
  { value: 'Nebraska', text: t('Nebraska') },
  { value: 'Nevada', text: t('Nevada') },
  { value: 'New Hampshire', text: t('New Hampshire') },
  { value: 'New Jersey', text: t('New Jersey') },
  { value: 'New Mexico', text: t('New Mexico') },
  { value: 'New York', text: t('New York') },
  { value: 'North Carolina', text: t('North Carolina') },
  { value: 'North Dakota', text: t('North Dakota') },
  { value: 'Ohio', text: t('Ohio') },
  { value: 'Oklahoma', text: t('Oklahoma') },
  { value: 'Oregon', text: t('Oregon') },
  { value: 'Pennsylvania', text: t('Pennsylvania') },
  { value: 'Puerto Rico', text: t('Puerto Rico') },
  { value: 'Rhode Island', text: t('Rhode Island') },
  { value: 'South Carolina', text: t('South Carolina') },
  { value: 'South Dakota', text: t('South Dakota') },
  { value: 'Tennessee', text: t('Tennessee') },
  { value: 'Texas', text: t('Texas') },
  { value: 'Utah', text: t('Utah') },
  { value: 'Vermont', text: t('Vermont') },
  { value: 'Virginia', text: t('Virginia') },
  { value: 'Washington', text: t('Washington') },
  { value: 'West Virginia', text: t('West Virginia') },
  { value: 'Wisconsin', text: t('Wisconsin') },
  { value: 'Wyoming', text: t('Wyoming') }
];
